import * as React from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useNavigate } from 'react-router-dom';
import { useCreateProviderMutation } from 'App/services/providerServiceApi';
import { toast } from 'react-toastify';
import { MenuItem, Select } from '@mui/material';

export default function ProviderFormDialog() {
  const [open, setOpen] = React.useState(false);
  const [providerName, setProviderName] = React.useState('');
  const [adStatus, setAdStatus] = React.useState(1);
  const navigate = useNavigate();

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);

  };

  const [createProvider, { isLoading,
    isFetching,
    isError,
    error
  }] = useCreateProviderMutation();



  const handleAddProvider = async (event) => {
    event.preventDefault();

    try {
  
      if (providerName) {
        await createProvider({ name: providerName, adStatus }).unwrap();
        toast.success("Provider Successfully Created!");
        handleClose();
        setProviderName('')
      }
      else {
        toast.error("Required to Provider Field name");
      }
    } catch (error) {
      toast.error(error.data.error);
      
    }
   
  }


  return (
    <React.Fragment>
      <Button variant="contained" color="light" onClick={handleClickOpen}>
        Add Provider
      </Button>
      <Dialog
        open={open}
        onClose={handleClose}
        PaperProps={{
          component: 'form',
          onSubmit: handleAddProvider,
        }}
      >
        <DialogTitle>Add Provider</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Enter the name of the Provider:
          </DialogContentText>
          <TextField
            autoFocus
            // required
            margin="dense"
            id="name"
            name='name'
            label="Provider Name"
            type="text"
            fullWidth
            value={providerName}
            onChange={(e) => setProviderName(e.target.value)}
            error={!!error}
          // helperText={error} 
          />
            <Select
            // required
            fullWidth
            sx={{ height: 40, mt: 2 }}
            value={adStatus}
            onChange={(e) => setAdStatus(e.target.value)}
            displayEmpty
          >
            <MenuItem
             value={1}>Active</MenuItem>
            <MenuItem value={0}>InActive</MenuItem>
          </Select>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button type="submit" disabled={isLoading} name="submit" >Add </Button>
          {isLoading && ' Loading...'}
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
